export default __webpack_public_path__ + "static/media/kitchen3-afterG.218169a8.jpg";